<template>
    <div :class="preCls + 'container-padding'">
        <div :class="preCls + 'content-box'">
            <Tabs class="router-view" :animated="false" v-model="active" @on-click="tabsChange">
                <TabPane label="公司资讯" :index="1" name="notifyList">
                    <Access name="notifyList">
                        <router-view
                            v-if="active == 'notifyList'"
                            :name="$access.aliasToUri('notifyList')"
                        ></router-view>
                    </Access>
                </TabPane>
                <TabPane label="广告设置" :index="2" name="notifyAdvertising">
                    <Access name="notifyAdvertising">
                        <router-view
                            v-if="active == 'notifyAdvertising'"
                            :name="$access.aliasToUri('notifyAdvertising')"
                        ></router-view>
                    </Access>
                </TabPane>
                <TabPane label="公司设置" :index="3" name="notifySet">
                    <Access name="notifySet">
                        <router-view
                            v-if="active == 'notifySet'"
                            :name="$access.aliasToUri('notifySet')"
                        ></router-view>
                    </Access>
                </TabPane>
            </Tabs>
        </div>
    </div>
</template>
<script>
import { Tabs, TabPane } from 'ivux'
export default {
    components: {
        Tabs,
        TabPane,
    },
    data() {
        return {
            active: 'notifyList'
        }
    },
    created() {},
    methods: {
        tabsChange(el) {}
    }
}
</script>